import { useState, useCallback } from 'react';

const STORAGE_KEY = 'solicitudes_color_mode';

// 'full'      → Renglon completo de color (modo tradicional)
// 'border'    → Borde izquierdo + chip de color, fondo blanco
// 'underline' → Línea base brillante inferior, fondo limpio
const VALID_MODES = ['full', 'border', 'underline'];

export function useColorMode() {
  const [colorMode, setColorModeState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return VALID_MODES.includes(saved) ? saved : 'full';
  });

  const setColorMode = useCallback((mode) => {
    if (!VALID_MODES.includes(mode)) return;
    localStorage.setItem(STORAGE_KEY, mode);
    setColorModeState(mode);
  }, []);

  return { colorMode, setColorMode };
}
